import { ArtBoardNS } from "../../../../../../ArtBoard/ArtBoardNS.js";
import { StrokeNS } from "../../../../../../Stroke/StrokeNS.js";
import { ViewBoxNS } from "../../../../../../ViewBox/ViewBoxNS.js";
import { ViewPortNS } from "../../../../../../ViewPort/ViewPortNS.js";
export const initEditor = (self) => {
  const canvas_el = self._getCanvasElThrowable();
  const layers_el = self._getLayersElThrowable();
  const target_image_layer_el = self._getTargetImageLayerElThrowable();
  const art_board_rect_el = self._getArtBoardRectElThrowable();
  const art_board_filter_drop_shadow_el =
    self._getArtBoardFilterDropShadowElThrowable();
  const art_board_shape_path_el = self._getArtBoardShapePathElThrowable();
  const target_image_dummy_g_el = self._getTargetImageDummyGElThrowable();
  const view_port = new ViewPortNS.ModelNS.ViewPort({
    width: 0,
    height: 0,
  });
  self._view_port = view_port;
  const view_port_controller = new ViewPortNS.ControllerNS.ViewPortController({
    view_port,
  });
  new ViewPortNS.ViewNS.ViewPortElView({
    view_port_el: canvas_el,
    view_port_controller,
  });
  new ViewPortNS.ViewNS.ViewPortElView({
    view_port_el: layers_el,
    view_port_controller,
  });
  const view_box = new ViewBoxNS.ModelNS.ViewBox({
    svg_el: self._svg_el,
    min_s: 1,
    max_s: 1,
  });
  self._view_box = view_box;
  const view_box_controller = new ViewBoxNS.ControllerNS.ViewBoxController({
    view_box,
  });
  new ViewBoxNS.ViewNS.ViewBoxElView({
    view_box_el: layers_el,
    view_box_controller,
  });
  const art_board = new ArtBoardNS.ModelNS.ArtBoard({
    width: 0,
    height: 0,
    svg_el: self._svg_el,
    getCTM: () => {
      const ctm = art_board_rect_el.getCTM();
      if (ctm == null) {
        throw new Error(`아트보드 엘리먼트의 CTM 을 구할 수 없습니다.`);
      }
      return ctm;
    },
  });
  self._art_board = art_board;
  const art_board_controller = new ArtBoardNS.ControllerNS.ArtBoardController({
    art_board,
  });
  new ArtBoardNS.ViewNS.ArtBoardView({
    art_board_controller,
    art_board_rect_el,
    art_board_filter_drop_shadow_el,
  });
  new ArtBoardNS.ViewNS.ArtBoardShapePathView({
    art_board_controller,
    art_board_shape_path_el,
  });
  const stroke = new StrokeNS.ModelNS.Stroke({
    svg_el: self._svg_el,
    getCTM: () => {
      const target_image_dummy_g_ctm = target_image_dummy_g_el.getCTM();
      if (target_image_dummy_g_ctm == null) {
        throw new Error(`target_image_dummy_g_el 의 CTM 을 구할 수 없습니다.`);
      }
      const target_image_layer_ctm = target_image_layer_el.getCTM();
      if (target_image_layer_ctm == null) {
        throw new Error(`target_image_layer_el 의 CTM 을 구할 수 없습니다.`);
      }
      return target_image_layer_ctm.multiply(target_image_dummy_g_ctm);
    },
  });
  const stroke_sync = new StrokeNS.ModelNS.StrokeSync({
    SVGGraphicsElement: self._window.SVGGraphicsElement,
    el: target_image_layer_el,
    stroke,
  });
  view_port_controller.subscribe(() => {
    if (self._target_image_el == null) {
      return;
    }
    stroke_sync.sync();
  });
  view_box_controller.subscribe(() => {
    if (self._target_image_el == null) {
      return;
    }
    stroke_sync.sync();
  });
  self._stroke_sync = stroke_sync;
};
